import produce from 'immer';
import { CHANGE_ACTIVE_STORE_SUCCESS } from 'redux/actions/user';
import {
  GET_ASPIRE_SYNC_LOGS_START,
  GET_ASPIRE_SYNC_LOGS_SUCCESS,
  GET_ASPIRE_SYNC_LOGS_FAILED,
  GET_TOUCHMD_SYNC_LOGS_START,
  GET_TOUCHMD_SYNC_LOGS_SUCCESS,
  GET_TOUCHMD_SYNC_LOGS_FAILED,
  GET_MODMED_SYNC_LOGS_START,
  GET_MODMED_SYNC_LOGS_SUCCESS,
  GET_MODMED_SYNC_LOGS_FAILED,
  GET_RPA_SYNC_LOGS_START,
  GET_RPA_SYNC_LOGS_SUCCESS,
  GET_RPA_SYNC_LOGS_FAILED,
  ADD_ASPIRE_LOG,
  ADD_TOUCHMD_LOG,
  ADD_MODMED_LOG,
  ADD_RPA_LOG
} from '../actions/sync_logs';


const initialState = {
  aspireSyncLogs: [],
  touchMDSyncLogs: [],
  modmedSyncLogs: [],
  rpaSyncLogs: [],
  aspireTotalCount: 0,
  touchMDTotalCount: 0,
  modmedTotalCount: 0,
  rpaTotalCount: 0,
  modmedPage: 0,
  touchMDPage: 0,
  aspirePage: 0,
  rpaPage: 0,
  loadingAspireLogs: false,
  loadingTouchMDLogs: false,
  loadingModmedLogs: false,
  loadingRpaLogs: false
};

const formReducer = produce((state: ISuncLogsState = initialState, action) => {
  switch (action.type) {
    case GET_ASPIRE_SYNC_LOGS_START: {
      state.loadingAspireLogs = true;
      break;
    }

    case GET_ASPIRE_SYNC_LOGS_SUCCESS: {
      const { data, totalCount, page } = action.data;

      state.aspireSyncLogs = data;
      state.aspireTotalCount = totalCount;
      state.aspirePage = page;
      state.loadingAspireLogs = false;
      break;
    }

    case GET_ASPIRE_SYNC_LOGS_FAILED: {
      state.loadingAspireLogs = false;
      break;
    }

    case GET_TOUCHMD_SYNC_LOGS_START: {
      state.loadingTouchMDLogs = true;
      break;
    }

    case GET_TOUCHMD_SYNC_LOGS_SUCCESS: {
      const { data, totalCount, page } = action.data;

      state.touchMDSyncLogs = data;
      state.touchMDTotalCount = totalCount;
      state.touchMDPage = page;
      state.loadingTouchMDLogs = false;
      break;
    }

    case GET_TOUCHMD_SYNC_LOGS_FAILED: {
      state.loadingTouchMDLogs = false;
      break;
    }

    case GET_MODMED_SYNC_LOGS_START: {
      state.loadingModmedLogs = true;
      break;
    }

    case GET_MODMED_SYNC_LOGS_SUCCESS: {
      const { data, totalCount, page } = action.data;

      state.modmedSyncLogs = data;
      state.modmedPage = page;
      state.modmedTotalCount = totalCount;
      state.loadingModmedLogs = false;
      break;
    }

    case GET_MODMED_SYNC_LOGS_FAILED: {
      state.loadingModmedLogs = false;
      break;
    }

    case GET_RPA_SYNC_LOGS_START: {
      state.loadingRpaLogs = true;
      break;
    }

    case GET_RPA_SYNC_LOGS_SUCCESS: {
      const { data } = action;

      state.rpaSyncLogs = data.response.data;
      state.rpaPage = data.response.current_page;
      state.rpaTotalCount = data.response.total;
      state.loadingRpaLogs = false;
      break;
    }

    case GET_RPA_SYNC_LOGS_FAILED: {
      state.loadingRpaLogs = false;
      break;
    }

    case ADD_ASPIRE_LOG: {
      const { data } = action;

      if (data?.type === 'created' && state.aspirePage === 1) {
        state.aspireSyncLogs = [data.log, ...state.aspireSyncLogs];
      } else if (data?.type === 'updated') {
        state.aspireSyncLogs = state.aspireSyncLogs.map((log) =>
          log.id === data.log.id ? data.log : log
        );
      }

      break;
    }

    case ADD_TOUCHMD_LOG: {
      const { data } = action;

      if (data?.type === 'created' && state.touchMDPage === 1) {
        state.touchMDSyncLogs = [data.log, ...state.touchMDSyncLogs];
      } else if (data?.type === 'updated') {
        state.touchMDSyncLogs = state.touchMDSyncLogs.map((log) =>
          log.id === data.log.id ? data.log : log
        );
      }

      break;
    }

    case ADD_MODMED_LOG: {
      const { data } = action;

      if (data?.type === 'created' && state.modmedPage === 1) {
        state.modmedSyncLogs = [data.log, ...state.modmedSyncLogs];
      } else if (data?.type === 'updated') {
        state.modmedSyncLogs = state.modmedSyncLogs.map((log) =>
          log.id === data.log.id ? data.log : log
        );
      }

      break;
    }

    case ADD_RPA_LOG: {
      const { data } = action;

      if (data?.type === 'created' && state.rpaPage === 1) {
        state.rpaSyncLogs = [data.log, ...state.rpaSyncLogs];
      } else if (data?.type === 'updated') {
        state.rpaSyncLogs = state.rpaSyncLogs.map((log) =>
          log.id === data.log.id ? data.log : log
        );
      }

      break;
    }

    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.aspireSyncLogs = initialState.aspireSyncLogs;
      state.touchMDSyncLogs = initialState.touchMDSyncLogs;
      state.modmedSyncLogs = initialState.modmedSyncLogs;
      state.rpaSyncLogs = initialState.rpaSyncLogs;
      state.aspireTotalCount = initialState.aspireTotalCount;
      state.touchMDTotalCount = initialState.touchMDTotalCount;
      state.modmedTotalCount = initialState.modmedTotalCount;
      state.rpaTotalCount = initialState.rpaTotalCount;
      state.modmedPage = initialState.modmedPage;
      state.touchMDPage = initialState.touchMDPage;
      state.aspirePage = initialState.aspirePage;
      state.rpaPage = initialState.rpaPage;
      break;
    }
  }
}, initialState);

export default formReducer;
